export function setConfig(state, payload) {
  state.config.API.BASE_URL = payload.Api.BaseUrl;
  state.config.API.CONTENT_BASE_URL = payload.Api.ContentBaseUrl;

  state.config.CACHCONTROLGUID = payload.CachControlGuid;

  state.config.DEFAULT_GTM_CODE = payload.DefaultGTMCode;
  state.config.DEFAULT_GA_CODE = payload.DefaultGACode;

  state.config.COLLECTIVITY_INFORMATION = payload.CollectivityInformation;
  state.config.ENFORCE_HTTPS = payload.EnforceHTTPS;
  state.config.ENVIRONMENT = payload.Environment;
  state.config.FRONT_END_URL = payload.FrontEndUrl;
  state.config.APPLICATION_INSIGHTS.INSTRUMENTATION_KEY = payload.ApplicationInsights.InstrumentationKey;
  state.config.APPLICATION_INSIGHTS.CONNECTION_STRING = payload.ApplicationInsights.ConnectionString;
  state.config.DAMAGE_INSURANCE_URL = payload.DamageInsuranceUrl;
}
